module.exports = __webpack_public_path__ + "img/task-handle-left.8cb90d03.svg";